import { motion } from 'framer-motion';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTheme, darken, alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import _ from '@lodash';
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
//import 'react-awesome-slider/dist/custom-animations/fold-out-animation.css';
import '../../../styles/awesome-slider.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from 'app/theme-layouts/shared-components/LanguageSwitcher';
import { Fragment, useState, useReducer, useEffect } from 'react';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Alert from '@mui/material/Alert';
import LoadingOverlay from "react-loading-overlay";
import { Loader } from "react-loaders";
import 'loaders.css/loaders.css';
import { resetLogin, submitCompany, submitPasswordLogin, submitNFCLogin, checkCompanyCookie, removeCompanyCookie } from 'app/store/loginSlice';
import { setStayLoggedIn, getStayLoggedIn } from 'app/store/abs/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import absWebService from 'app/services/absWebService';
import Lottie from 'react-lottie';
import nfcscan from './nfcscan';
import { showMessage } from 'app/store/abs/messageSlice';
import history from '@history';

LoadingOverlay.propTypes = undefined;

const useStyles = makeStyles(theme => ({
	root: {
		'& .awssld__bullets': {
			zIndex: 111,
			bottom: "20px",
			'& button': {
				background: theme.palette.secondary.light,
			}
		}
	},
	slidercontent_style1: {
		background: `linear-gradient(to right, ${alpha(theme.palette.secondary.light, 0.85)} 0%, ${alpha(darken(
			theme.palette.secondary.light,
			0.5
		), 0.85)} 100%)`,
		color: theme.palette.primary.contrastText
	},
	badge: {
		backgroundColor: theme.palette.secondary.light,
		color: theme.palette.secondary.contrastText
	},
	copyright: {
		color: theme.palette.text.primary + "!important"
	},
	loader: {
		'& div': {
			borderColor: theme.palette.primary.light + "!important"
		}
	},
	disabledcolor: {
		"& :disabled": {
			color: theme.palette.text.secondary
		},
		"& label": {
			color: theme.palette.text.secondary + "!important"
		}
	},
	sliderpiccopyright: {
		color: 'rgba(255,255,255,0.7)!important',
		background: 'rgba(0,0,0,0.5)!important',
		fontSize: '10px'
	}
}));

const defaultValues = {
	logindata: {
		company: '',
		username: '',
		password: ''
	},
	keeplogin: getStayLoggedIn(),
	companyvalided: false,
	loading: false,
	companyname: ''
};

//define visibility
const showforgotpw = true;
const shownocustomeryet = false;

function reducer(state, action) {
	switch (action.type) {
		case 'resetCompany': {
			return {
				...state,
				logindata: {
					company: '',
					username: '',
					password: ''
				},
				companyvalided: false,
				companyname: ''
			};
		}
		case 'toggleKeepLogin': {
			setStayLoggedIn(!state.keeplogin);
			return {
				...state,
				keeplogin: !state.keeplogin
			};
		}
		case 'setLogindata': {
			return {
				...state,
				logindata: {
					...state.logindata,
					[action.name]: action.value
				}
			};
		}
		case 'setCompanyValidated': {
			return {
				...state,
				companyvalided: true,
				companyname: action.value
			};
		}
		case 'setLoading': {
			return {
				...state,
				loading: action.value
			};
		}
		default: {
			throw new Error();
		}
	}
}

const AutoplaySlider = withAutoplay(AwesomeSlider);

function LoginPage() {
	const dispatch_ext = useDispatch();
	const login = useSelector(({ login }) => login);
	const classes = useStyles();
	const { t } = useTranslation('loginpage');
	const [state, dispatch] = useReducer(reducer, defaultValues);
	const theme = useTheme();

	const schema_company = yup.object().shape({
		company: yup.string().required(t("COMPANYREQUIRED")).matches(/^[aA-zZ0-9._-]+$/, t("INVALIDINPUT"))
		//.min(3, t("SHORTINPUT"))
	});

	const schema_user = yup.object().shape({
		username: yup.string().required(t("USERNAMEREQUIRED")).matches(/^[aA-zZ0-9@._-]+$/, t("INVALIDINPUT")),
		password: yup.string().required(t("PASSWORDREQUIRED"))
	});

	const { control, formState, handleSubmit, reset, setError, clearErrors } = state.companyvalided ?
		useForm({
			mode: 'onChange',
			state,
			resolver: yupResolver(schema_user)
		})
		:
		useForm({
			mode: 'onChange',
			state,
			resolver: yupResolver(schema_company)
		})

	const { isValid, dirtyFields, errors } = formState;

	const [showPassword, setShowPassword] = useState(false);

	const [nfcSupport, setNfcSupport] = useState("none");
	const [loginMethod, setLoginMethod] = useState(localStorage.getItem("abs_loginmethod") ? localStorage.getItem("abs_loginmethod") : "password");
	const [nfcreturn, setNfcReturn] = useState({});

	useEffect(() => {

		if (login.type != null) {
			dispatch({
				type: 'setLoading',
				value: false
			});
		}

		if (login.success) {
			if (login.type == "company") {
				reset();
				dispatch({
					type: 'setCompanyValidated',
					value: login.companyname
				});

				if (loginMethod == "nfc") {
					startNFCScan();
				}
			}
			else //then user
			{
				//nothing to do here
			}
		}
		else {
			if (login.errors != null && login.errors.length > 0) {
				login.errors.forEach(error => {
					setError(error.type, {
						type: 'manual',
						message: error.message
					});
				});
			}
		}
	}, [login, setError]);

	//on start
	useEffect(() => {
		//check if really only on start - not again after successful login
		if (login.type == null) {
			dispatch({
				type: 'setLoading',
				value: true
			});
			dispatch_ext(checkCompanyCookie());
			setNfcSupport(absWebService.getNFCSupportCookie());

			document.addEventListener("nfcscan.recieved", nfcScanReceived);
		}
	}, []);
	//on end
	useEffect(() => () => {
		document.removeEventListener("nfcscan.recieved", nfcScanReceived);

	}, []);

	function nfcScanReceived(e) {
		var rtn = JSON.parse(e?.detail);

		setNfcReturn(rtn);

		if (rtn?.nfcEvent == "success" && rtn?.serialNumber != null) {
			endNFCScan();

			var chiptxt = "";
			if (rtn?.savedCompany != null && rtn?.savedUsername != null) {
				chiptxt = rtn?.savedCompany + ":" + rtn?.savedUsername;
			}
			dispatch_ext(submitNFCLogin({ chiptext: chiptxt, serialnumber: rtn?.serialNumber }));
		}
		else if (rtn?.nfcEvent == "error") {
			setError("alert", {
				type: 'manual',
				message: t(rtn?.nfcText)
			});
		}
	}

	//currently only password login
	function onSubmit(model) {

		// //set logindata for each object in model
		// for (var key in model) {
		// 	if (model.hasOwnProperty(key)) {
		// 		setLogindata({name: key, value: model[key]})
		// 	}
		// }

		dispatch({
			type: 'setLoading',
			value: true
		});

		if (!state.companyvalided) {
			//set company to state
			var key = "company";
			if (model.hasOwnProperty(key)) {
				setLogindata({ name: key, value: model[key] })

				dispatch_ext(submitCompany(model));
			}
			//fallback, never should be called
			else {
				resetCompany();
			}
		}
		else {
			//set username to state
			var key = "username";
			if (model.hasOwnProperty(key)) {
				setLogindata({ name: key, value: model[key] })
			}
			//set password to state
			var key = "password";
			if (model.hasOwnProperty(key)) {
				setLogindata({ name: key, value: model[key] })
			}

			model.keeplogin = state.keeplogin;
			dispatch_ext(submitPasswordLogin(model));
		}
	}

	function setLogindata(target) {
		dispatch({
			type: 'setLogindata',
			name: target.name,
			value: target.value
		});
	}

	function resetCompany() {
		dispatch_ext(removeCompanyCookie());
		dispatch({
			type: 'resetCompany'
		});
		reset();
	}

	function handleCBChange() {
		dispatch({
			type: 'toggleKeepLogin'
		});
	}

	function resetLoginClick() {
		dispatch_ext(resetLogin());
	}

	function getRightSubHeaderMessage() {
		if (state?.companyvalided) {
			switch (loginMethod) {
				case "nfc":
					return t("HEADERSUBMESSAGENFC");
				default:
					return t("HEADERSUBMESSAGEUSER");
			}
		}
		else
			return t("HEADERSUBMESSAGECOMPANY");
	}

	function startNFCScan() {
		clearErrors("alert");

		if (typeof window.callAppHook === 'function') {
			window.callAppHook("nfclogin");
		}
	}
	function endNFCScan() {
		if (typeof window.callAppHook === 'function') {
			window.callAppHook("nfcdestroy");
		}
	}

	useEffect(() => {
		clearErrors("alert");

		switch (loginMethod) {
			case "nfc":
				if (typeof window.callAppHook === 'function') {
					localStorage.setItem("abs_loginmethod", loginMethod);
					if (state.companyvalided) {
						startNFCScan();
					}
				}
				else {
					setLoginMethod("password");
					dispatch_ext(showMessage({ message: t("NFCNOTAVAILABLE"), variant: 'error' }));
				}
				break;
			default:
				localStorage.setItem("abs_loginmethod", "password");
				break;
		}
	}, [loginMethod]);

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.2 } }} className={clsx(classes.root, 'flex flex-auto p-16 sm:p-24 flex-row md:p-0 overflow-hidden justify-center')}>
			<div className="hidden md:flex md:flex-1">
				<AutoplaySlider animation="foldOutAnimation" className="h-screen" play={true} bullets={true} organicArrows={false} infinite={false} cancelOnInteraction={false} interval={8000}>
					<div data-src="assets/images/login/TL_BG1.jpg" >
						<div className={clsx(classes.slidercontent_style1, "z-10 p-64 m-32 rounded-16")}>
							<img className="w-128 mb-32" src="assets/images/logos/tl_orig.svg" alt="logo" />

							<Typography className="text-32 sm:text-44 font-semibold leading-tight">
								<span style={{ color: "#8fb5d6" }}>TimeLite</span>® in der <br /> Alpsware Business Suite
							</Typography>

							<Typography variant="subtitle1" className="mt-32 font-medium">
								Zeit-, Projekt- und Aufgabenerfassung, sowie Dienst- und Urlaubsplanung sind keine Neuheiten mehr - doch nachvollziehbar, einfach und komplett anpassbar, DAS kann nur TimeLite.
							</Typography>
							<Button variant="outlined" className="w-auto mt-32 bg-neutral-50" href='https://timelite.businesssuite.at'>
								Mehr erfahren
							</Button>
						</div>
						{/* <a href='https://alpsware.at' className={clsx(classes.sliderpiccopyright,"absolute bottom-0 left-0 p-4")}>
							Picture Copyright Democontent
						</a> */}
					</div>
					<div data-src="assets/images/login/PM_BG3.jpg">
						<div className={clsx(classes.slidercontent_style1, "z-10 p-64 m-32 rounded-16")}>
							<img className="w-128 mb-32" src="assets/images/logos/pm_orig.svg" alt="logo" />

							<Typography className="text-32 sm:text-44 font-semibold leading-tight">
								<span style={{ color: "#a57fb2" }}>Kundenmanagement</span> in der <br /> Alpsware Business Suite
							</Typography>

							<Typography variant="subtitle1" className="mt-32 font-medium">
								Dynamisches Kunden- und Beziehungsmanagement für Ihr Unternehmen!
								<br /><br />
								Bald verfügbar!
							</Typography>
						</div>
						{/* <a href='https://alpsware.at' className={clsx(classes.sliderpiccopyright,"absolute bottom-0 left-0 p-4")}>
							Picture Copyright Democontent
						</a> */}
					</div>
					<div data-src="assets/images/login/IV_BG2.jpg">
						<div className={clsx(classes.slidercontent_style1, "z-10 p-64 m-32 rounded-16")}>
							<img className="w-128 mb-32" src="assets/images/logos/iv_orig.svg" alt="logo" />

							<Typography className="text-32 sm:text-44 font-semibold leading-tight">
								<span style={{ color: "#ea7600" }}>Inventur</span> in der <br /> Alpsware Business Suite
							</Typography>

							<Typography variant="subtitle1" className="mt-32 font-medium">
								Leichte Inventur- und Lagebestandsverwaltung verknüpfbar mit Ihrem Onlineshop und Kassensystem!
								<br /><br />
								Bald verfügbar!
							</Typography>
						</div>
						{/* <a href='https://alpsware.at' className={clsx(classes.sliderpiccopyright,"absolute bottom-0 left-0 p-4")}>
							Picture Copyright Democontent
						</a> */}
					</div>
					<div data-src="assets/images/login/BB_BG1.jpg">
						<div className={clsx(classes.slidercontent_style1, "z-10 p-64 m-32 rounded-16")}>
							<img className="w-128 mb-32" src="assets/images/logos/bb_orig.svg" alt="logo" />

							<Typography className="text-32 sm:text-44 font-semibold leading-tight">
								<span style={{ color: "#c33d55" }}>Rechnungslegung</span> in der <br /> Alpsware Business Suite
							</Typography>

							<Typography variant="subtitle1" className="mt-32 font-medium">
								Automatische Rechnungserstellung und Versendung für maximale Effizienz!
								<br /><br />
								Bald verfügbar!
							</Typography>
						</div>
						{/* <a href='https://alpsware.at' className={clsx(classes.sliderpiccopyright,"absolute bottom-0 left-0 p-4")}>
							Picture Copyright Democontent
						</a> */}
					</div>
					<div data-src="assets/images/login/EK_BG1.jpg">
						<div className={clsx(classes.slidercontent_style1, "z-10 p-64 m-32 rounded-16")}>
							<img className="w-128 mb-32" src="assets/images/logos/eo_orig.svg" alt="logo" />

							<Typography className="text-32 sm:text-44 font-semibold leading-tight">
								<span style={{ color: "#489c60" }}>Exkursio</span> in der <br /> Alpsware Business Suite
							</Typography>

							<Typography variant="subtitle1" className="mt-32 font-medium">
								Ihr digitales Fahrtenbuch für genaue Nachverfolgung der letzten Routen der Firmenwägen & Carpoolmanagement!
								<br /><br />
								Jetzt verfügbar!
							</Typography>
						</div>
						{/* <a href='https://alpsware.at' className={clsx(classes.sliderpiccopyright,"absolute bottom-0 left-0 p-4")}>
							Picture Copyright Democontent
						</a> */}
					</div>
				</AutoplaySlider>
			</div>
			<div className="flex flex-col w-full max-w-md justify-center">
				<Card
					className="flex w-full h-full max-w-md items-center justify-center mx-auto m-16 md:m-0 rounded-20 md:rounded-none flex-col"
					square
				>
					<CardContent
						component={motion.div}
						initial={{ x: 200 }}
						animate={{ x: 0, transition: { delay: 0.5 } }}
						transition={{ bounceDamping: 0 }}
						className="flex flex-col items-center justify-between lg:w-full max-w-sm p-32 h-full"
					>
						<div className="hidden md:block"></div>
						<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.4 } }}>
							<div className="flex items-center mb-16">
								<img className="logo-icon h-128" src="assets/images/logos/BS-DBlau.svg" alt="logo" />
							</div>

							<Typography variant="h6" className="font-semibold text-18 sm:text-24">
								{t("HEADERMESSAGE")}
							</Typography>
							<Typography variant="h6" className="mb-24 text-12 sm:text-18">
								{getRightSubHeaderMessage()}
							</Typography>

							{!!errors.alert &&
								<Alert severity="error" variant="filled" className="mb-32">{errors?.alert?.message}</Alert>
							}
							<LoadingOverlay tag="div" active={state.loading}
								styles={{
									overlay: (base) => ({
										...base,
										background: theme.palette.background.paper,
										opacity: 0.5
									}),
								}}
								spinner={
									<Loader active type="ball-pulse-sync" color={theme.palette.primary.light} style={{ transform: 'scale(0.8)' }} innerClassName={classes.loader} />
								}>
								<form
									name="loginForm"
									noValidate
									className="flex flex-col justify-center w-full"
									onSubmit={handleSubmit(onSubmit)}
								>
									{!state.companyvalided ?
										<motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}>
											<Controller
												name="company"
												control={control}
												render={({ field }) => (
													<Autocomplete
														freeSolo
														options={absWebService.getCompanyHistory()}
														value={field.value || ''}
														onChange={(event, newValue) => {
															field.onChange(newValue || '');
														}}
														onInputChange={(event, newInputValue) => {
															field.onChange(newInputValue || '');
														}}
														renderInput={(params) => (
															<TextField
																{...params}
																className="mb-16"
																type="text"
																label={t("COMPANYCODE")}
																autoFocus
																error={!!errors.company}
																helperText={errors?.company?.message}
																variant="outlined"
																InputProps={{
																	...params.InputProps,
																	endAdornment: (
																		<InputAdornment position="end">
																			<Icon className="text-20" color="action">
																				business
																			</Icon>
																		</InputAdornment>
																	)
																}}
																required
																fullWidth
															/>
														)}
													/>
												)}
											/>
											<div className="flex flex-col items-center justify-center mt-16">
												<Button
													variant="contained"
													color="primary"
													className="w-8/12"
													aria-label="LOG IN"
													disabled={_.isEmpty(dirtyFields) || !isValid}
													type="submit"
												>
													{t("SUBMITCOMPANY")}
												</Button>
											</div>
										</motion.div>
										:
										loginMethod == "password" ?
											<Fragment>
												<motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}>
													<div className="flex items-center justify-center mb-32 noselection">
														<IconButton onClick={resetCompany} className="mr-8">
															<Icon>undo</Icon>
														</IconButton>
														<TextField
															type="text"
															label={t("COMPANY")}
															className={classes.disabledcolor}
															variant="standard"
															InputProps={{
																disableUnderline: true,
																endAdornment: (
																	<InputAdornment position="end">
																		<Icon className="text-20" color="action">
																			business
																		</Icon>
																	</InputAdornment>
																)
															}}
															fullWidth
															disabled
															value={state.companyname != null && state.companyname != "" ? state.companyname : state.logindata.company}
														/>
													</div>

													<Controller
														name="username"
														control={control}
														render={({ field }) => (
															<Autocomplete
																freeSolo
																options={absWebService.getUsernameHistory(state.logindata.company)}
																value={field.value || ''}
																onChange={(event, newValue) => {
																	field.onChange(newValue || '');
																}}
																onInputChange={(event, newInputValue) => {
																	field.onChange(newInputValue || '');
																}}
																renderInput={(params) => (
																	<TextField
																		{...params}
																		className="mb-16"
																		type="text"
																		label={t("USERNAME")}
																		autoFocus
																		error={!!errors.username}
																		helperText={errors?.username?.message}
																		variant="outlined"
																		InputProps={{
																			...params.InputProps,
																			endAdornment: (
																				<InputAdornment position="end">
																					<Icon className="text-20" color="action">
																						person
																					</Icon>
																				</InputAdornment>
																			)
																		}}
																		required
																		fullWidth
																	/>
																)}
															/>
														)}
													/>

													<Controller
														name="password"
														control={control}
														render={({ field }) => (
															<TextField
																{...field}
																className="mb-16"
																label={t("PASSWORD")}
																type="password"
																error={!!errors.password}
																helperText={errors?.password?.message}
																variant="outlined"
																InputProps={{
																	className: 'pr-2',
																	type: showPassword ? 'text' : 'password',
																	endAdornment: (
																		<InputAdornment position="end">
																			<IconButton onClick={() => setShowPassword(!showPassword)}>
																				<Icon className="text-20" color="action">
																					{showPassword ? 'visibility' : 'visibility_off'}
																				</Icon>
																			</IconButton>
																		</InputAdornment>
																	)
																}}
																required
																fullWidth
															/>
														)}
													/>
												</motion.div>

												<div className="flex flex-col sm:flex-row items-center justify-center sm:justify-between">
													<Controller
														name="remember"
														control={control}
														render={({ field }) => (
															<FormControl>
																<FormControlLabel label={t("KEEPLOGIN")} control={<Checkbox {...field} defaultChecked={state.keeplogin} onChange={handleCBChange} />} />
															</FormControl>
														)}
													/>
													{showforgotpw &&
														<Link className="font-normal" to="/forgotpassword">
															<span onClick={() => resetLoginClick()}>{t("FORGOTPW")}</span>
														</Link>
													}
												</div>
												<div className="flex flex-col items-center justify-center mt-16">
													<Button
														variant="contained"
														color="primary"
														className="w-8/12"
														aria-label="LOG IN"
														disabled={_.isEmpty(dirtyFields) || !isValid}
														type="submit"
													>
														{t("SUBMITLOGIN")}
													</Button>
													{nfcSupport != "none" &&
														<Fragment>
															<div className="flex w-full items-center my-24">
																<div className="flex-auto mt-px border-t-2" />
																<Typography className="mx-16" color="text.secondary">
																	{t("ALTERNATIVELOGIN")}
																</Typography>
																<div className="flex-auto mt-px border-t-2" />
															</div>
															<Button
																variant="outlined"
																color="primary"
																className="w-8/12"
																aria-label="NFC LOG IN"
																onClick={() => setLoginMethod("nfc")}
															>
																{t("NFCLOGIN")}
															</Button>
														</Fragment>
													}
												</div>
											</Fragment>
											:
											loginMethod == "nfc" ?
												<Fragment>
													<motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}>
														<div className="flex items-center justify-center mb-24 noselection">
															<IconButton onClick={() => {
																resetCompany();
																endNFCScan();
															}} className="mr-8">
																<Icon>undo</Icon>
															</IconButton>
															<TextField
																type="text"
																label={t("COMPANY")}
																className={classes.disabledcolor}
																variant="standard"
																InputProps={{
																	disableUnderline: true,
																	endAdornment: (
																		<InputAdornment position="end">
																			<Icon className="text-20" color="action">
																				business
																			</Icon>
																		</InputAdornment>
																	)
																}}
																fullWidth
																disabled
																value={state.companyname != null && state.companyname != "" ? state.companyname : state.logindata.company}
															/>
														</div>
														<div className='flex flex-col justify-center'>
															{!errors.alert &&
																<Typography className="p-16 w-full text-center" color="text.secondary">
																	{t(nfcreturn?.nfcText)}
																</Typography>
															}
															{(!errors.alert && (nfcreturn?.nfcEvent != "success" || nfcreturn?.serialNumber != null)) ?
																<Lottie
																	options={{
																		loop: true,
																		autoplay: true,
																		animationData: nfcscan,
																		rendererSettings: {
																			preserveAspectRatio: "xMidYMid slice"
																		}
																	}}
																	height={128}
																	width={128}
																/>
																:
																<Button
																	variant="outlined"
																	color="primary"
																	className="w-full mt-8"
																	onClick={() => startNFCScan()}>
																	{t("STARTNEWSCAN")}
																</Button>
															}
														</div>
														<div className="flex flex-col items-center justify-center mt-32">
															<div className="flex w-full items-center">
																<div className="flex-auto mt-px border-t-2" />
																<Typography className="mx-16" color="text.secondary">
																	{t("ALTERNATIVELOGIN")}
																</Typography>
																<div className="flex-auto mt-px border-t-2" />
															</div>
															<Button
																variant="text"
																color="primary"
																className="w-8/12 mt-8"
																aria-label="PASSWORD LOG IN"
																onClick={() => {
																	setLoginMethod("password");
																	endNFCScan();
																}}>
																{t("PASSWORDLOGIN")}
															</Button>
															<Button
																variant="text"
																color="primary"
																className="w-8/12 mt-8"
																onClick={() => {
																	endNFCScan();
																	resetLoginClick();
																	history.push("/chipinfo");
																}}>
																{t("NFCHIPINFO")}
															</Button>
														</div>
													</motion.div>
												</Fragment>
												:
												<Fragment>
													Unknown Login Method
												</Fragment>
									}
								</form>
							</LoadingOverlay>
						</motion.div>
						{/* same as below */}
						<div className="text-center hidden md:block m-16">
							<div className="mb-8">
								<LanguageSwitcher />
							</div>
							{shownocustomeryet &&
								<div className="flex flex-col sm:flex-row opacity-80 items-center justify-center sm:justify-between pb-16">
									<span className="font-normal md:pr-8">{t("NOCUSTOMERYET")}</span>
									<Link className="font-normal" to="/register">
										{t("BECOMENEWCUSTOMER")}
									</Link>
								</div>
							}
							<div className="flex items-center justify-center gap-16 mb-4">
								<a href="https://alpsware.at/dsgvo/" className={clsx("opacity-80", classes.copyright)}>
									{t("DSGVO")}
								</a>
								<a href="https://alpsware.at/agbs-abs/" className={clsx("opacity-80", classes.copyright)}>
									{t("AGB")}
								</a>
							</div>
							<a href="https://alpsware.at" className={clsx("opacity-80", classes.copyright)}>
								{t("COPYRIGHT")} {new Date().getFullYear()}
							</a>
						</div>
					</CardContent>
				</Card>
				<div className="text-center md:hidden m-16 bottom-0">
					<div className="mb-8">
						<LanguageSwitcher />
					</div>
					{shownocustomeryet &&
						<div className="flex flex-col sm:flex-row opacity-80 items-center justify-center sm:justify-between pb-16">
							<span className="font-normal md:pr-8">{t("NOCUSTOMERYET")}</span>
							<Link className="font-normal" to="/register">
								{t("BECOMENEWCUSTOMER")}
							</Link>
						</div>
					}
					<div className="flex items-center justify-center gap-16 mb-4">
						<a href="https://alpsware.at/dsgvo/" className={clsx("opacity-80", classes.copyright)}>
							{t("DSGVO")}
						</a>
						<a href="https://alpsware.at/agbs-abs/" className={clsx("opacity-80", classes.copyright)}>
							{t("AGB")}
						</a>
					</div>
					<a href="https://alpsware.at" className={clsx("opacity-80", classes.copyright)}>
						{t("COPYRIGHT")} {new Date().getFullYear()}
					</a>
				</div>
			</div>
		</motion.div>
	);
}

export default LoginPage;
